<template>
  <div class="content">
    <img src="../assets/img/zscqyyfw/zscqyyfw.png" alt="" style="width: 100%;height: 320px;">
  <div style="width: 100%;display: flex;justify-content: center;background-color: rgba(0,2,13, 0.7);height: 437px;flex-wrap: wrap;">
 <div style="width: 100%;display: flex;justify-content: center;position: relative;">
  <div class="contentname">Online bidding
    <div class="contentname1">在线竞价</div>
  </div>

 </div>
 <div  class="tablist">
  <div class="tabss">
    <div :class="tabis==item?'tabsson':'tabssonother'" v-for="item,index in tablists" :key="index" @click="tabchange(item)">{{ item }}
      <div class="tabwl" v-if="tabis==item"></div>
    </div>
  </div>
 </div>
    <div class="tablelist">
      <el-table
             empty-text="暂无数据"
             height="100%"
              :header-cell-style="{ backgroundColor: '#03091F', color: '#fff', fontSize: '12px', borderBottom: '1px #03091F solid' }"
              :cell-style="{ borderBottom: '1px #03091F solid',color:'#86A5C8' }"
              ref="gocarTable1"
              :data="tableData" tooltip-effect="dark" style="width: 100%;height: 240px;" @select="gocarlistset"
            :default-sort="{ prop: 'date', order: 'descending' }"
            :row-class-name="tableRowClassName"
            >

                 <el-table-column prop="xmmc" label="" show-overflow-tooltip align="center"> </el-table-column>
              <el-table-column prop="ssly" label="" show-overflow-tooltip align="center"> </el-table-column>
      
              <el-table-column prop="dwqy" label="" align="center" show-overflow-tooltip> </el-table-column>
              <el-table-column label="" align="center" width="125"  show-overflow-tooltip>
                <template #default="scope">{{ scope.row.lxfs }}</template>
              </el-table-column>
            </el-table>
            <!-- 信息总量 -->
            <div style="width: 100%;display: flex;justify-content: center;align-items: center;padding-top: 13px;">
              <div class="listnum" v-if="listnum>0">共 {{ listnum }}条</div>
              <el-pagination
              v-if="listnum>0"
              style="margin-left: 20px;"
              :page-size="5"
            @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
  background
  layout="prev, pager, next"
  :total="listnum">
</el-pagination></div>
         
    </div>
  </div>
  
           

  </div>
  </template>
  
  <script>
  
  
  
  
  export default {
    name: 'zxjjContent',
    components: {
  
     
    },
    data(){
      return{
        listnum:0,
        tableData:[],
        tablists:[],
        tabis:'在线竞价'
      }
    },
    mounted(){
      
    },
    methods:{
      handlecurrweipai(e){
  console.log(e);
},
// 表颜色
tableRowClassName({rowIndex}) {

  console.log(rowIndex);
        if (rowIndex%2 ==0) {
          return 'warning-row';
        } else  {
          return 'success-row';
        }
        // return '';
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },
      tabchange(item){
this.tabis = item
      }
    }
  }
  </script>
  
  <style scoped>
.content{
  width: 100%;
    height:calc( 100vh - 196px) ;
    background: #fff;
    background-image: url('../assets/img/jyzx/beij.png'); 
  background-size: cover;
  background-repeat: no-repeat; 
  background-position: center; 
}



::v-deep .el-table .warning-row {
    background: #000416;
  }


  ::v-deep  .el-table .success-row {
    background: #01081E;
  }
  ::v-deep   .el-table__inner-wrapper:before{
    width: 0;

  }
  .tablelist{
    width: 1200px;
    height: 301px;
    background-color: #000618;
    cursor: pointer;
    margin-top: 16px;
  }
  .listnum{
    font-family: PingFang SC, PingFang SC;
font-weight: normal;
font-size: 14px;
color: #B9C5D1;
font-style: normal;
text-transform: none;
  }
  .contentname{
    display: flex;
    justify-content: center;
    width: 372px;
    font-family: Source Han Sans CN, Source Han Sans CN;
font-weight: 700;
font-size: 36px;
font-style: normal;
text-transform: none;
color: rgba(185,197,209, 0.1);
position: relative;
  }
  .contentname1{
    position: absolute;
    top: 35px;
    left: 133px;
    font-family: Source Han Sans, Source Han Sans;
font-weight: 400;
font-size: 24px;
color: #FFFFFF;
font-style: normal;
text-transform: none;
  }
  .tablist{
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .tabss{
    width: 1200px;
    height: 48px;
margin-top: 22px;
display: flex;
justify-content: space-between;
cursor: pointer;
background: #010A2A;
  }
  .tabsson{
    width: 360px;
height: 48px;
display: flex;
background: #010A2A;
justify-content: center;
align-items: center;
font-family: Source Han Sans, Source Han Sans;
font-weight: 500;
font-size: 16px;
color: #FFFFFF;
font-style: normal;
text-transform: none;
position: relative;
  }
  .tabwl{
    position: absolute;
    width: 224px;
height: 2px;
background: linear-gradient( 90deg, rgba(22,92,226,0) 0%, #0328f8 48%, rgba(22,92,226,0) 100%);
border-radius: 4px 4px 4px 4px;
bottom: 2px;
left: 68px;
  }
  .tabssonother{
    width: 360px;
height: 48px;
background: #010A2A;
border-radius: 4px 4px 4px 4px;
display: flex;
justify-content: center;
align-items: center;
font-family: Source Han Sans, Source Han Sans;
font-weight: 400;
font-size: 16px;
color: #B9C5D1;
font-style: normal;
text-transform: none;
  }
/* //修改分页选中默认的背景色 */
:deep(.el-pagination.is-background .el-pager li:not(.is-disabled).is-active) {
  background-color: #165CE2 !important;
}

/* 未选中 */
::v-deep .el-pagination.is-background .el-pager li:not(.disabled) {
  background-color: #1A213A !important;
  color: #FFF !important;

}

::v-deep .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager,
::v-deep .el-pagination.is-background .btn-next:disabled,
::v-deep .el-pagination.is-background .btn-prev,
::v-deep .el-pagination.is-background .btn-prev:disabled {
  background-color: #000618;
  color: #fff;
}
::v-deep  .el-table__body-wrapper{
  background-color: #000618;
}
  </style>
  
  